// extracted by mini-css-extract-plugin
module.exports = {"container":"pricing-module--container--1SAoe","content":"pricing-module--content--2X1k8","text":"pricing-module--text--3tTlO"};